import styled from 'styled-components';

import { colorWhite, colorGrayDark, mediaQueryTabletMin } from 'styles';

export const Wrapper = styled.div`
  display: block;
  position: absolute;
  top: calc(50% - 24px);
  right: 16px;
  z-index: 4;

  @media ${mediaQueryTabletMin} {
    left: calc(50% - 24px);
    right: auto;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.14);

  && {
    background-color: ${colorWhite};
  }

  & svg {
    width: 12px;
    height: 13px;
    fill: ${colorGrayDark};
    transform: rotate(90deg);
  }

  &:hover,
  &:focus {
    background-color: ${colorWhite};
  }

  &:active {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  @media ${mediaQueryTabletMin} {
    & svg {
      transform: rotate(0deg);
    }
  }
`;
